export default "__VITE_ASSET__f8ebc3f6__"